export const getTimeZoneMark = (): string => {
  const offset = new Date().getTimezoneOffset();
  const value = Math.abs(offset);
  const prefix = `GMT${offset < 0 ? '+' : '-'}`;

  return (
    prefix +
    `00${Math.floor(value / 60)}`.slice(-2) +
    `00${value % 60}`.slice(-2)
  );
};
